/**
 * El nombre de un país o de una moneda, en el idioma de quien mira el panel.
 *
 * El catálogo de países y monedas lo manda el servidor con los nombres en
 * castellano, porque es la misma lista que decide en qué moneda se crea un
 * precio y no conviene tener dos. Pero un panel en inglés que dice «Estados
 * Unidos» y «Dólar estadounidense» se nota a la legua. `Intl.DisplayNames` ya
 * sabe cómo se llama cada código en cada idioma, así que se traduce aquí, a
 * partir del código, y el nombre del servidor queda de respaldo por si el
 * navegador no lo conoce.
 */

function displayName(type: 'region' | 'currency', code: string, language: string, fallback: string): string {
  try {
    const name = new Intl.DisplayNames([language], { type }).of(type === 'currency' ? code.toUpperCase() : code)
    /* Un código que no conoce lo devuelve tal cual: eso no es un nombre. */
    if (name && name.toUpperCase() !== code.toUpperCase()) return name.charAt(0).toLocaleUpperCase(language) + name.slice(1)
  } catch { /* navegador sin `Intl.DisplayNames`: vale el del servidor */ }
  return fallback
}

export function countryLabel(code: string, language: string, fallback: string): string {
  return displayName('region', code, language, fallback)
}

export function currencyLabel(code: string, language: string, fallback: string): string {
  return displayName('currency', code, language, fallback)
}
